import { useTableSort } from '@/shared/hooks/useTableSort';
import { Data } from '@dnd-kit/core';
import { SortableColumnDef } from '../TableV2/SortableTable';
import { DraggableTable, DraggableTableProps } from './DraggableTable';

type SortableDraggableTableProps<T> = {
  columns: SortableColumnDef<T>[];
} & DraggableTableProps<T>;

export const SortableDraggableTable = <T extends Data>({
  columns,
  ...draggableTableProps
}: SortableDraggableTableProps<T>) => {
  const { rows, columns: sortableColumns } = useTableSort({
    rows: draggableTableProps.rows,
    columns,
  });

  return (
    <DraggableTable<T>
      {...draggableTableProps}
      columns={sortableColumns}
      rows={rows}
    />
  );
};
